export default [
  {
    path: '/tabela-precos',
    name: 'app-admin-tabela-precos',
    component: () => import('@/views/apps/tabela-preco/list/TabelaPrecoList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Tabela de Preços',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Lista de Tabelas de Preços',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tabela-precos/add-item/:id',
    name: 'app-admin-tabela-precos-add-item',
    component: () => import('@/views/apps/tabela-preco/edit/ListTabelaPrecoItem.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Tabela de Preços',
      action: 'update',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Lista de Tabelas de Preços',
          active: false,
          to: '/tabela-precos',
        },
        {
          text: 'Adicionar Item',
          active: true,
        },
      ],
    },
  },
]
